import "core-js/modules/es.array.includes.js";
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
export default defineNuxtPlugin(function (nuxtApp) {
  var runtimeConfig = useRuntimeConfig();
  var vueApp = nuxtApp.vueApp;
  Sentry.init({
    Vue: Vue,
    dsn: runtimeConfig.public.SENTRY_DSN || '',
    environment: runtimeConfig.public.SENTRY_ENVIRONMENT || 'local',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: runtimeConfig.public.SENTRY_TRACE_SAMPLE_RATE || 1.0,
    release: runtimeConfig.public.SENTRY_RELEASE || 'local',
    attachStacktrace: true,
    autoSessionTracking: true,
    logErrors: true,
    tracingOptions: {
      hooks: ['mount', 'update', 'create'],
      trackComponents: true
    },
    ignoreErrors: [/Network Error/i],
    beforeSend: function beforeSend(event, hint) {
      // Check if it is an exception, and if so, log it.
      if (event.exception) {
        var _hint$originalExcepti, _originalExceptionRes;
        var originalExceptionResponse = hint === null || hint === void 0 ? void 0 : (_hint$originalExcepti = hint.originalException) === null || _hint$originalExcepti === void 0 ? void 0 : _hint$originalExcepti.response;
        var errorMessages = ['Could not find an address based on the provided data.', 'The house number field must be at least 1.', 'Provide a valid Dutch or Belgium zipcode (e.g. 1234AB or 1234 AB / 1234)', 'The house number field must be an integer.'];
        if (errorMessages.includes(originalExceptionResponse === null || originalExceptionResponse === void 0 ? void 0 : (_originalExceptionRes = originalExceptionResponse.data) === null || _originalExceptionRes === void 0 ? void 0 : _originalExceptionRes.message)) {
          return null;
        }

        // eslint-disable-next-line no-console
        console.error("[Exeption handled by Sentry]: (".concat(hint.originalException, ")"), {
          event: event,
          hint: hint
        });
      }
      // Continue sending to Sentry
      return event;
    }
  });
  vueApp.mixin(Sentry.createTracingMixins({
    trackComponents: true,
    timeout: 2000,
    hooks: ['activate', 'mount', 'update']
  }));
  Sentry.attachErrorHandler(vueApp, {
    logErrors: true,
    attachProps: true,
    trackComponents: true,
    timeout: 2000,
    hooks: ['activate', 'mount', 'update']
  });
  nuxtApp.provide('sentry', Sentry);
  return {
    provide: {
      $sentry: Sentry
    }
  };
});